import { InstantLoanStateType } from "../../../Reducers/types"
import { Validators } from "../../types"

export const residentialDetailsValidators: Validators<InstantLoanStateType["residentialDetails"]> =
  {
    addressAutocomplete(value, values) {
      if (!value && !values.addressCivicNumber) return "Required"
    },
    addressCivicNumber(value, values) {
      if (!value) return "Required"
    },
    addressStreet(value, values) {
      if (!value) return "Required"
    },
    addressAptNumber(value, values) {},
    addressCity(value, values) {
      if (!value) return "Required"
    },
    addressPostalCode(value, values) {
      if (!value) return "Required"
      if (value.length < 6) return "Must have X9X 9X9 format"
      if (!/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$/.test(value))
        return "Must be valid postal code"
    },
    addressStateId(value, values) {
      if (!value) {
        return "Required"
      }
    },
    addressCountryId(value, values) {
      if (!value) {
        return "Required"
      }
    },
    addressStatusId(value, values) {
    },
    addressResidenceTypeId(value, values) {
      // if (!value || !parseInt(value)) return "Required"
    },
    addressAmountRentMortgage(value, values) {
      // required only if rent or owning with mortgage
      // if (!value && value !== 0) return "Required"
    },
  }

